import { Injectable } from '@angular/core';

import { FsMapPanoramasServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapPanoramasFacadeService<
  TMap extends IFsMap,
> extends FsMapPanoramasServiceProvider<TMap> {
  constructor(private readonly provider: FsMapPanoramasServiceProvider<TMap>) {
    super();
  }

  public get id(): string {
    return this.provider.id;
  }

  public get geospatialProvider(): string {
    return this.provider.geospatialProvider;
  }

  public onMapLoaded(map: TMap): void {
    return this.provider.onMapLoaded(map);
  }

  public addToMap(): void {
    return this.provider.addToMap();
  }

  public removeFromMap(): void {
    return this.provider.removeFromMap();
  }
}
